import ENDPOINTS from 'shared/api/endpoints';
import UrlModifier from 'shared/utils/url';
import RequestClient from 'shared/api/http-client';

import type { EventResults, LatestResult } from './types';

export async function fetchLatestResults(params: {
  sport_id: string; // comma-separated ids
  num_events: number;
}): Promise<LatestResult[]> {
  const { sport_id, num_events } = params;

  const res = await RequestClient.get(ENDPOINTS.LATEST_RESULTS_LISTS, {
    params: { sport_id, num_events },
  });

  const data = res.data;
  const list = Array.isArray(data) ? data : Object.values(data || {});
  return list as LatestResult[];
}

export async function fetchEventResults(params: {
  event_id: number | string;
  schedule_id?: number | string | null;
}): Promise<EventResults> {
  const { event_id, schedule_id } = params;
  if (event_id == null || String(event_id).trim() === '') {
    return {} as EventResults;
  }
  if (schedule_id != null && String(schedule_id).trim() !== '') {
    const url =
      UrlModifier.bindToUrl(ENDPOINTS.SCHEDULE_EVENT_RESULTS_WEB, {
        schedule_id: String(schedule_id),
        event_id: String(event_id),
      }) ?? '';
    const res = await RequestClient.get(url);
    return (res.data || {}) as EventResults;
  }
  const url = UrlModifier.bindToUrl(ENDPOINTS.EVENT_RESULTS_LISTS, { event_id }) ?? '';
  const res = await RequestClient.get(url);
  return (res.data || {}) as EventResults;
}

